/**
 * Convert raw PCM buffer to WAV buffer by prepending proper WAV header
 * @param {Buffer} pcmData - Raw PCM data buffer
 * @param {number} sampleRate - Sample rate in Hz (default: 16000)
 * @param {number} bitDepth - Bit depth (default: 16)
 * @param {number} channels - Number of channels (default: 1 for mono)
 * @returns {Buffer} - WAV formatted buffer
 */
function convertPCMBufferToWAV(pcmData, sampleRate = 16000, bitDepth = 16, channels = 1) {
	try {
		const pcmDataSize = pcmData.length;

		// Calculate WAV file parameters
		const bytesPerSample = bitDepth / 8;
		const blockAlign = channels * bytesPerSample;
		const byteRate = sampleRate * blockAlign;
		const wavFileSize = 44 + pcmDataSize; // 44 bytes header + PCM data

		// Create WAV header (44 bytes)
		const header = Buffer.alloc(44);

		// RIFF chunk descriptor
		header.write('RIFF', 0, 4);                           // ChunkID
		header.writeUInt32LE(wavFileSize - 8, 4);             // ChunkSize (file size - 8)
		header.write('WAVE', 8, 4);                           // Format

		// fmt sub-chunk
		header.write('fmt ', 12, 4);                          // Subchunk1ID
		header.writeUInt32LE(16, 16);                         // Subchunk1Size (16 for PCM)
		header.writeUInt16LE(1, 20);                          // AudioFormat (1 for PCM)
		header.writeUInt16LE(channels, 22);                   // NumChannels
		header.writeUInt32LE(sampleRate, 24);                 // SampleRate
		header.writeUInt32LE(byteRate, 28);                   // ByteRate
		header.writeUInt16LE(blockAlign, 32);                 // BlockAlign
		header.writeUInt16LE(bitDepth, 34);                   // BitsPerSample

		// data sub-chunk
		header.write('data', 36, 4);                          // Subchunk2ID
		header.writeUInt32LE(pcmDataSize, 40);                // Subchunk2Size (PCM data size)

		// Combine header and PCM data
		const wavData = Buffer.concat([header, pcmData]);

		return wavData;

	} catch (error) {
		console.error('Failed to convert PCM buffer to WAV:', error);
		throw new Error(`PCM to WAV conversion failed: ${error.message}`);
	}
}

module.exports = {
	convertPCMBufferToWAV
};
